export default __webpack_public_path__ + "static/media/Winners-desktop.9c14ca13.png";